import React from 'react';

import AutocompleteSelector from './index';
import UserInfoChip from '../UserInfoChip';
import CompactUserInfo from '../CompactUserInfo';

export default class UserSelector extends AutocompleteSelector {
  static defaultProps = {
    ...AutocompleteSelector.defaultProps,
    placeholder: 'Enter names or email addresses',
    searchableProps: ['firstName', 'lastName', 'fullName', 'subtitle', 'email'],
    selectionTemplate: <CompactUserInfo />,
    selectedEntryTemplate: <UserInfoChip id={-1} />  //id = -1 is added to work around proptypes restriction of UserInfoChip
  }
}